import { Component, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Config } from '@config';
import { AuthHttp } from '@http';
import { WebAccessService } from './web-access.service';
import { UrlEnhancerService } from '@url';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { States, StateService } from '@state';

@Component({
    selector: 'web-access-screen',
    templateUrl: './web-access.template.html',
    preserveWhitespaces: true,
    standalone: false
})
export class WebAccessScreen implements AfterViewInit, OnDestroy {

    public constructor(
        private config: Config,
        private webAccessService: WebAccessService,
        private urlEnhancer: UrlEnhancerService,
        private changeDetector: ChangeDetectorRef,
        private domSanitizer: DomSanitizer,
        public stateService: StateService
    ) {
        const themeConfig = this.stateService.value(States.themeConfig).get();
        this.enableUITwo = themeConfig.enableUITwo || false;
    }

    public enableUITwo = false;
    public launchWebAccessUrl: SafeUrl;
    public openInTabUrl: string;

    private touchProxySessionTimeout: number;
    private isDestroyed: boolean;

    private touchProxySession(): void {
        this.webAccessService.touchProxySession().finally(() => {
            if (!this.isDestroyed) {
                this.touchProxySessionTimeout = window.setTimeout(
                    () => this.touchProxySession(),
                    this.config.services.webAccess.touchProxySessionIntervalMilliseconds);
            }
        });
    }

    public refresh(): void {
        const url = this.launchWebAccessUrl;
        this.launchWebAccessUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('about:blank');
        this.changeDetector.detectChanges();
        this.launchWebAccessUrl = url;
    }

    public openInNewTab() {
        window.open(this.openInTabUrl, '_blank', '');
    }

    public ngAfterViewInit(): void {
        this.launchWebAccessUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
            this.urlEnhancer.replaceParams(this.config.services.webAccess.launchWebAccessUrl, {inFrame: true}));
        this.openInTabUrl = this.urlEnhancer.replaceParams(
            this.config.services.webAccess.launchWebAccessUrl, {inFrame: false});
        this.touchProxySessionTimeout = window.setTimeout(
            () => this.touchProxySession(),
            this.config.services.webAccess.touchProxySessionIntervalMilliseconds);
        this.changeDetector.detectChanges();
    }

    public ngOnDestroy(): void {
        if (this.touchProxySessionTimeout) {
            this.isDestroyed = true;
            window.clearTimeout(this.touchProxySessionTimeout);
        }
    }
}
